const shopify = {
  namespaced: true,
  state: () => ({
    shopifyProducts: [],
    loading: false,
  }),

  mutations: {
    SET_SHOPIFY_PRODUCTS(state, products) {
      state.shopifyProducts = products;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
  },
  getters: {
    shopifyProducts: (state) => state.shopifyProducts,
    loading: (state) => state.loading,
  },
};
export default shopify;
